// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".equal-size[data-v-50dd681a] {\n  flex-grow: 1;\n  flex-basis: 0;\n  min-width: 0;\n}", ""]);
// Exports
module.exports = exports;
